module.exports = __webpack_public_path__ + "img/video-11.63c098e7.png";